import { render, staticRenderFns } from "./CowDisposal.vue?vue&type=template&id=304ba1b4&scoped=true&"
import script from "./CowDisposal.vue?vue&type=script&lang=js&"
export * from "./CowDisposal.vue?vue&type=script&lang=js&"
import style0 from "./CowDisposal.vue?vue&type=style&index=0&id=304ba1b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304ba1b4",
  null
  
)

export default component.exports